import moment from 'moment';

const getDateFormat = (date) => {
  return moment(date).format('DD-MM-YYYY hh:mm A');
}

export default getDateFormat;
